const breadcrumbsHome = { name: 'Home', pathName: '/home', onlyAvailableOnVue2: true }
const breadcrumbsAplicativo = { name: 'Aplicativo', pathName: null }
const breadcrumbsComunidades = { name: 'Comunidades', pathName: '/v3/mobile/comunidades' }

const communitiesMeta = {
  requiredModules: ['communities'],
  requiredUserPermissions: ['mobile/comunidades'],
}

export default [
  {
    path: '/v3/mobile',
    component: () => import('@/views/BaseRoutingComponent.vue'),
    children: [
      {
        path: 'comunidades',
        name: 'list-communities',
        component: () => import('@/modules/mobile/comunidades/pages/Index.vue'),
        meta: {
          title: 'Comunidades',
          ...communitiesMeta,
          breadcrumbs: [breadcrumbsHome, breadcrumbsAplicativo, { name: 'Comunidades', pathName: null }],
        },
      },
      {
        path: 'comunidades/novo',
        name: 'new-community',
        component: () => import('@/modules/mobile/comunidades/pages/Edit.vue'),
        meta: {
          title: 'Nova comunidade',
          ...communitiesMeta,
          breadcrumbs: [breadcrumbsHome, breadcrumbsAplicativo, breadcrumbsComunidades, { name: 'Nova comunidade', pathName: null }],
        },
      },
      {
        path: 'comunidades/:id',
        name: 'edit-community',
        component: () => import('@/modules/mobile/comunidades/pages/Edit.vue'),
        meta: {
          title: 'Editar comunidade',
          ...communitiesMeta,
          breadcrumbs: [breadcrumbsHome, breadcrumbsAplicativo, breadcrumbsComunidades, { name: 'Editar comunidade', pathName: null }],
        },
      },
      {
        path: 'comunidades/:id/sucesso',
        name: 'community-success',
        component: () => import('@/modules/mobile/comunidades/pages/Success.vue'),
        meta: {
          title: 'Comunidade criada',
          ...communitiesMeta,
          breadcrumbs: [breadcrumbsHome, breadcrumbsAplicativo, breadcrumbsComunidades, { name: 'Comunidade criada', pathName: null }],
        },
      },
    ],
  },
]
